// Import the patch before using react-virtualized components
import "./react-virtualized-patch";
import "./main.css";
import appStores from "./appStoresConfig";
// components/RootStore/injectStores now delegates to @intrasync/react's
// injectStores registry - the same registry the accounting module (and any
// other shared @intrasync/* module) reads from - so a single setup call
// populates everything. Do NOT add a second call to @intrasync/react's
// setupInjectStores: it has replace semantics and would discard the extra
// built-in store names registered by the adapter.
import { setupInjectStores } from "./components/RootStore/injectStores";
import serviceStores from "serviceStoresConfig";

import { pwaRegistration } from "./pwaUtils";
import { renderApp } from "./renderApp";
import { createRootStore } from "./createRootStore";
import { startAppInsights } from "./startAppInsights";

// Before anything else, so a failure during store setup or render is
// captured rather than lost. No-ops when no key is configured.
startAppInsights();

const rootStore = createRootStore();

pwaRegistration(rootStore);

setupInjectStores(appStores, serviceStores)
  .then(() => {
    renderApp(rootStore);
  })
  .catch((error) => {
    console.error("Error setting up stores", error);
  });
